import React, { PropsWithChildren, useState } from "react";
import { IconButton, Menu, ThemeProvider, createTheme } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

type TableActionButtonProps = {
  stopPropagation?: boolean;
  color?: string;
};

const TableActionButton = ({ stopPropagation = false, color, children }: PropsWithChildren<TableActionButtonProps>) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handleIconButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchorEl(event.currentTarget);
    stopPropagation && event.stopPropagation();
  };

  const handleMenuItemClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setMenuAnchorEl(null);
    stopPropagation && event.stopPropagation();
  };

  const handleMenuItemClose = () => {
    setMenuAnchorEl(null);
  };

  const theme = createTheme({});

  const menuTheme = createTheme({
    components: {
      MuiSvgIcon: {
        styleOverrides: {
          root: {
            height: 18,
            width: 18,
            marginRight: "0.5rem"
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <IconButton onClick={handleIconButtonClick} sx={{color}}>
        <MoreVertIcon />
      </IconButton>

      <ThemeProvider theme={menuTheme}>
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuItemClose}
          onClick={handleMenuItemClick}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              sx: {
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)",
                border: "1px solid #E5E7EB",
                mt: 0.5,
              }
            }
          }}
        >
          {children}
        </Menu>
      </ThemeProvider>
    </ThemeProvider>
  );
};

export default TableActionButton;